const PasswordRequirements = () => {
  return (
    <div className="mb-4 relative text-subtle">
      <p className="text-sm">Password Requirements:</p>
      <ul className="pl-3 list-disc list-inside text-xs leading-relaxed">
        <li>Must be at least 10 characters long.</li>
        <li>Must include at least one uppercase letter (A-Z).</li>
        <li>Must include at least one lowercase letter (a-z).</li>
        <li>Must include at least one number (0-9).</li>
        <li>Must include at least one special character (e.g., !@#$%^&*).</li>
      </ul>
    </div>
  )
}

export default PasswordRequirements
